module.exports = __webpack_public_path__ + "media/images/centauro-ab31adb3b8c44603363cc16d13a8723e.png";